import React, { useReducer } from 'react'
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { defaultReducer } from '../../Utils/reducers'
import DefaultModal from '../../Utils/DefaultModal'
import ColorButton from '../../Buttons/ColorButton'
import { PhoneInput } from '../../Utils/MaskedInput';
import MegaAutoComplete from '../../Utils/megautocomplete'
import './styles.css'

const EditUsers = ({ data, handleClose, submit, enterprises, groups, sellers }) => {

    const [state, setState] = useReducer(defaultReducer, {
        id: 0,
        username: '',
        email: '',
        telephone: '',
        active: true,
        ...data,
        enterprises: (data.enterprises || '').split(',').map(e => e.trim()) || [],
        groups: (data.groups || '').split(',').map(e => e.trim()) || [],
    })

    return (
        <>
            <DefaultModal
                open={true}
                handleClose={handleClose}
                title={<>{Boolean(data.id) ? 'Alterar' : 'Criar'} Usuário</>}
                content={
                    <Box className='item-content-modal noborder'>
                        <Box className='item-switch'>
                            <ColorButton onClick={() => setState({ active: true })} reverse={!state.active}>Ativo</ColorButton>
                            <ColorButton onClick={() => setState({ active: false })} reverse={state.active}>Inativo</ColorButton>
                        </Box>
                        <Box className='item-profile-row'>
                            <TextField
                                id="username"
                                type="text"
                                label="Usuário"
                                size='small'
                                value={state.username}
                                onChange={(e) => { setState({ 'username': e.target.value }) }}
                                fullWidth={false}
                                inputProps={{
                                    maxLength: 50
                                }}
                            />
                        </Box>
                        <Box className='item-profile-row'>
                            <TextField
                                id="email"
                                type="text"
                                label="E-mail"
                                size='small'
                                value={state.email}
                                onChange={(e) => { setState({ 'email': e.target.value }) }}
                                fullWidth={false}
                                inputProps={{
                                    maxLength: 50
                                }}
                            />
                            <TextField
                                id="telephone"
                                type="text"
                                label="Telefone"
                                size='small'
                                value={state.telephone}
                                onChange={(e) => { setState({ 'telephone': e.target.value }) }}
                                fullWidth={false}
                                inputProps={{
                                    maxLength: 50
                                }}
                                InputProps={{
                                    inputComponent: PhoneInput
                                }}
                            />
                        </Box>
                        <FormControl size='small'>
                            <InputLabel id='main-select-empresas'>Empresas</InputLabel>
                            <Select
                                labelId='main-select-empresas'
                                label='Empresas'
                                multiple={true}
                                value={state.enterprises}
                                onChange={({ target }) => setState({ enterprises: target.value })}
                            >
                                {enterprises.map(enterprise =>
                                    <MenuItem value={String(enterprise.id)}>{enterprise.label}</MenuItem>)}
                            </Select>
                        </FormControl>
                        <FormControl size='small'>
                            <InputLabel id='main-select-grupos'>Grupos</InputLabel>
                            <Select
                                labelId='main-select-grupos'
                                label='Grupos'
                                multiple={true}
                                value={state.groups}
                                onChange={({ target }) => setState({ groups: target.value })}
                            >
                                {groups.map(group =>
                                    <MenuItem value={group.label}>{group.label}</MenuItem>)}
                            </Select>
                        </FormControl>
                        <FormControl size='small'>
                            <InputLabel id='main-select-sellers'>Vendedor</InputLabel>
                            <Select
                                labelId='main-select-sellers'
                                label='Vendedor'
                                value={state.seller}
                                onChange={({ target }) => setState({ seller: target.value })}
                            >
                                {sellers.map(seller =>
                                    <MenuItem value={seller.id}>{seller.seller?.label}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Box>
                }
                action={
                    <ColorButton onClick={() => submit(state)}>salvar</ColorButton>

                }
            />
        </>
    )
}

export default EditUsers